import axios from "../axios-auth";

export const supplierService = {
  getSupplierList,
  saveSupplier,
  getSupplierDetail,
  getAllSupplier,
  getCurrencyBySupplierId
};

function getSupplierList(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.companyName) {
    params["companyName"] = searchParams.companyName;
  }

  return axios.get("/auth/suppliers", { params });
}

function saveSupplier(supplier) {
  if (!supplier.id) {
    return axios.post("/auth/supplier", supplier);
  } else {
    return axios.put("/auth/supplier", supplier);
  }
}
function getSupplierDetail(id) {
  return axios.get("/auth/supplier/" + id);
}

function getAllSupplier() {
  return axios.get("/auth/all-supplier");

}

function getCurrencyBySupplierId(supplierId) {
  return axios.get("/auth/currency-by-supplier/" + supplierId);
}
